import { IAssigneesStoreState } from "@gtmhub/assignees";
import { localize } from "@gtmhub/localization";
import { Assignee, AssigneeSelectorType, UnknownAssignee } from "../models/assignee.models";

export const assigneeFromRedux = (state: IAssigneesStoreState, assigneeId: string, options?: { hideDeleted: boolean }): Assignee | UnknownAssignee => {
  if (!assigneeId) {
    return undefined;
  }

  if (!state.assignees.isFetched) {
    return { id: assigneeId, isUnknown: true, name: localize("loading"), avatar: "refresh", color: "#87a6bc" };
  }

  if (options?.hideDeleted) {
    return state.assignees.map[assigneeId] || undefined;
  } else {
    return state.assignees.map[assigneeId] || deletedAssignee(assigneeId);
  }
};

export const isUnknownAssignee = (assignee: Assignee | UnknownAssignee): assignee is UnknownAssignee => "isUnknown" in assignee;

export const deletedAssignee = (id: string): UnknownAssignee => ({ id, isUnknown: true, name: localize("deleted_user"), avatar: "unknown", color: "#87a6bc" });

export const respectsAssignPermissions = (assignee: Assignee, assignPermissions: AssigneeSelectorType): boolean =>
  (assignPermissions !== "team" && assignee.type === "user") || (assignPermissions !== "user" && assignee.type === "team");
